function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3708"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3637",
  transform: "translate(12104 10918.696)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#007D39",
  "data-name": "Tracciato 3708",
  d: "M-12091.813-10918.696a12.208 12.208 0 00-12.187 12.187c0 6.713 12.187 23.313 12.187 23.313s12.187-16.6 12.187-23.313a12.208 12.208 0 00-12.187-12.187zm0 18.487a6.3 6.3 0 116.3-6.3 6.281 6.281 0 01-6.3 6.3z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#007D39",
  "data-name": "Ellisse 519",
  cx: 7,
  cy: 7,
  r: 7,
  transform: "translate(-12099 -10913.696)"
})));

function SvgMarkerActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24.374 35.503",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMarkerActive;